import styled from "styled-components";

export const PrincipalDiv = styled.div`
  color: white;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
`;

export const BaseDiv = styled.div`
  width: 100%;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
    padding: 4% 10px;
  }
`;

export const ContentDiv = styled.div`
  color: #15191a;
  width: 100%;
  display: flex;
  line-height: 1.5;
  justify-content: space-evenly;
  margin-top: 6rem;
  margin-bottom: 6rem;

  h1 {
    font-size: 2.8rem;
    margin-bottom: 10px;
    color: #15191a;
    font-family: 'Montserrat', sans-serif;
  }
  p {
    font-size: 1rem;
    margin: 5px 0;
    color: #15191a;
    font-family: 'Montserrat', sans-serif;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
  font-size: 2.8rem;
  line-height: 1.1;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  gap: 20px;
  width: 50%;
  .desktop-break {
    display: inline;
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    text-align: center;
    gap: 10px;
    margin-bottom: 1rem;
     .desktop-break {
      display: none;
    }
  }
`;

export const Logo = styled.img`
  height: 90px;
  width: auto;
  object-fit: contain;
  display: block;
  margin-right: 15px; /* Usar px em vez de % para evitar recalculos */
  margin-top: 10px;

  @media (max-width: 800px) {
    height: 80px;
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

export const AddressDiv = styled.div`
  padding: 10px;
  min-height: 100px;
  border-right: 1px solid white;

  @media (max-width: 800px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid white;
    padding: 5px; /* Reduzir padding */
  }
`;

export const ContactDiv = styled.div`
  padding: 10px;
  margin-left: 10px;

  @media (max-width: 800px) {
    text-align: center;
    width: 100%;
    margin-left: 0;
    padding: 5px; /* Reduzir padding */
  }
`;

export const IconsDiv = styled.div`
  padding: 2px;
  display: flex;
  gap: 10px;
  margin-top: 10px;

  .icons {
    width: 1.5em;
    height: 1.5em;
    cursor: pointer;

    @media (max-width: 800px) {
      width: 2.0em;
      height: 2.0em;
    }
  }
`;

export const ContentDivText = styled.div`
  display: flex;
  justify-content: space-evenly;
`;

export const CopyRight = styled.div`
  text-align: center;
  margin-top: 2%;
  color: var(--purple-dark);
  font-weight: bold;
  background-color: white;

  p {
    margin: 5px 0;
    color: var(--purple-dark);
  }

  strong {
    color: var(--orange);
  }

  @media (max-width: 1450px) {
    margin: 2% 0;
  }
`;